export default __webpack_public_path__ + "static/media/objective.fc3f10db.jpg";